module.exports = __webpack_public_path__ + "static/img/thumb-03.37ae87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/thumb/thumb-03.png
// module id = qbyY
// module chunks = 150